"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require("../AbstractReactComponent");

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

require("./NavIconText.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta ikony s nějakým textem (nebo komponentou), možné uspořádání - ikony vedle a ikona nad.
 */
var NavIconText = function (_AbstractReactCompone) {
    (0, _inherits3.default)(NavIconText, _AbstractReactCompone);

    function NavIconText() {
        (0, _classCallCheck3.default)(this, NavIconText);
        return (0, _possibleConstructorReturn3.default)(this, (NavIconText.__proto__ || (0, _getPrototypeOf2.default)(NavIconText)).apply(this, arguments));
    }

    (0, _createClass3.default)(NavIconText, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                icon = _props.icon,
                text = _props.text;


            return _react2.default.createElement(
                "div",
                { className: "icon-text-wrapper" },
                _react2.default.createElement(
                    "div",
                    { className: "icon-text-container" },
                    _react2.default.createElement(
                        "div",
                        { className: "icon-text-icon" },
                        icon
                    ),
                    text && _react2.default.createElement(
                        "div",
                        { className: "icon-text-text" },
                        text
                    )
                )
            );
        }
    }]);
    return NavIconText;
}(_AbstractReactComponent2.default); // --


NavIconText.propTypes = {
    icon: _react2.default.PropTypes.node,
    text: _react2.default.PropTypes.node
};
exports.default = NavIconText;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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